export const HOVER_DELAY_FIRST_LEVEL = 400;
export const HOVER_DELAY_SECOND_LEVEL = 100;
export const NAVIGATION_STALE_TIME = 600000;
export const NAVIGATION_ACCORDION_CLOSE_DELAY = 300;
export const SEARCH_INPUT_DELAY = 300;
export const SEARCH_QUERY_URL_PARAM = 'qu';
